import { Controller } from "@hotwired/stimulus"

// A Turbo-frame modal overlay. Closing empties the #modal frame (no server round-trip):
// the ✕ button, a backdrop click, or Escape all remove the overlay. On open, focus moves
// into the panel; on close it returns to the trigger (the gear) if still present.
export default class extends Controller {
  static targets = ["panel"]

  connect() {
    this.previouslyFocused = document.activeElement
    if (this.hasPanelTarget) this.panelTarget.focus()
  }

  close() {
    const frame = this.element.closest("turbo-frame")
    if (frame) {
      frame.innerHTML = ""
    } else {
      this.element.remove()
    }
    if (this.previouslyFocused && this.previouslyFocused.focus) this.previouslyFocused.focus()
  }

  backdrop(event) {
    if (event.target === this.element) this.close()
  }

  escape(event) {
    if (event.key === "Escape") this.close()
  }
}
